// extracted by extract-css-chunks-webpack-plugin
module.exports = {"mortgage-control-page__wrapper":"_39aNeu"};